import React from 'react';
import Event from '../../models/Event';
import _ from 'lodash';
import Collection from '../../models/Collection';
import PresentMode from '../../images/presentation-icon-black.png';

import { eventApi } from '../../api/EventApi';
import { EventVisibilityType } from '../../models/EventVisibilityType';


export class DeetTop extends React.Component {

  state = {
    sharelinkClicked: false,
    liveViewClicked: false
  };

  updateStepper (event) {
    this.setState({
      sharelinkClicked: eventApi.getStash(`${event.id}:sharelinkClicked`),
      liveViewClicked: eventApi.getStash(`${event.id}:liveViewClicked`)
    });
  }

  componentDidMount () {
    const { event } = this.props;
    this.updateStepper(event);
  }

  componentDidUpdate (prevProps) {
    const { event } = this.props;
    if (Event.getId(prevProps.event) !== Event.getId(event)) {
      this.updateStepper(event);
    }
  }

  handleGoClick = ($event) => {
    $event.preventDefault();

    const { event, handleGoClick } = this.props;
    handleGoClick(event);
  };

  handleShareClick = ($event) => {
    $event.preventDefault();

    const { event, handleShareClick } = this.props;

    eventApi.setStash(`${event.id}:sharelinkClicked`, true);
    this.setState({
      sharelinkClicked: true
    });

    handleShareClick(event);
  };

  handleInviteClick = ($event) => {
    $event.preventDefault();

    const { event, handleInviteClick } = this.props;

    eventApi.setStash(`${event.id}:sharelinkClicked`, true);
    this.setState({
      sharelinkClicked: true
    });

    handleInviteClick(event);
  };

  handlePresentClick = ($event) => {
    $event.preventDefault();

    const { event, handlePresentClick } = this.props;

    eventApi.setStash(`${event.id}:liveViewClicked`, true);
    this.setState({
      liveViewClicked: true
    });

    handlePresentClick(event);
  };

  handleEditClick = ($event) => {
    $event.preventDefault();

    const { event, handleEditClick } = this.props;
    handleEditClick(event);
  };

  getName = () => {
    const { event } = this.props;
    let name;
    if (_.get(event, 'collection.name')) {
      name = Collection.getName(Event.getCollection(event));
    }
    return name;
  }

  getQuestionCount = () => {
    const { event } = this.props;
    const collection = Event.getCollection(event);
    if (!!collection) {
      return Collection.getEventCount(collection);
    } else {
      return 0;
    }
  }

  render () {
    const { isDesktop, event } = this.props;
    if (!event) {
      return null;
    }

    return (
      <div className="container">
        { !!isDesktop && !!Event.isUserCreated(event) && (!this.state.sharelinkClicked || !this.state.liveViewClicked) && (
          <div className="stepper-horiz mt-3" style={{ background: 'none' }}>
            <div className="stepper done" style={{ backgroundColor: '#f9fafc' }}>
              <i className="material-icons" style={{ color: '#3D9AE2' }}>check_circle</i>
              <span className="stepper-text p-1">1. Create </span>
            </div>
            <div className={`stepper ${this.state.sharelinkClicked ? 'done' : ''}`} style={{ backgroundColor: '#f9fafc' }}>
              <i className={`material-icons stepper-text`} style={{ color: this.state.sharelinkClicked ? '#3D9AE2' : ''} }>{ this.state.sharelinkClicked ? 'check_circle' : 'panorama_fish_eye'}</i>
              <span className="stepper-text p-1">
                { Event.getVisibilityType(event) === EventVisibilityType.INVITE_ONLY ? '2. Invite' : '2. Share' }
              </span>
            </div>
            <div className={`stepper ${this.state.liveViewClicked ? 'done' : ''}`} style={{ backgroundColor: '#f9fafc' }}>
              <i className="material-icons stepper-text" >panorama_fish_eye</i>
              <span className="stepper-text stepper-text p-1">
                3. Present
              </span>
            </div>
          </div>
        )}
        { (!!Event.isUserCreated(event) || this.getName()) && (
        <div className="row pt-3 no-gutters">
          <div className={ `${Event.getVisibilityType(event) === EventVisibilityType.INVITE_ONLY ? 'col-lg' : 'col-lg' } col-sm-6 text-left` }>
            <h1 className={ `h2 pl-2 ${isDesktop ? '' : 'text-center'}` }>
              { this.getName() }
            </h1>
          </div>
          <div className="col-lg-auto col-sm-6">
            { !!Event.isUserCreated(event) && (
              <button className="btn btn-float btn-sm btn-light"
                data-toggle="tooltip" data-placement="top" title="Edit"
                onClick={ this.handleEditClick }
                type="button"><i className="material-icons">edit</i></button>
            )}
            <button className="btn btn-float btn-sm btn-light ml-3"
              data-toggle="tooltip" data-placement="top" title="Copy sharelink"
              onClick={ this.handleShareClick }
              type="button">
                <i className="material-icons">insert_link</i>
            </button>
            { Event.getVisibilityType(event) === EventVisibilityType.INVITE_ONLY && (
              <button className="btn btn-float btn-sm btn-light ml-3"
                data-toggle="tooltip" data-placement="top" title="Click to Invite People"
                onClick={ this.handleInviteClick }
                type="button">
                  <i className="material-icons">email</i>
              </button>
            ) }
            { !!Event.isUserCreated(event) && (
              <button className="btn btn-float btn-sm btn-light ml-3"
                data-toggle="tooltip" data-placement="top" title="Presentation view"
                onClick={ this.handlePresentClick }
                type="button">
                  <img src={ PresentMode } className="contents" alt="Live View" width="20" />
              </button>
            )}
          </div>
        </div>
        )}

      </div>
    );
  }
}
